import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  listFilters: {
    prCode: "",
    status: "",
    category: "",
    department: "",
    region: "",
    page: 0,
    size: 10,
  },
  detailActiveTab: "detail",
}

const procurementSlice = createSlice({
  name: "procurement",
  initialState,
  reducers: {
    setListFilters: (state, { payload }) => {
      state.listFilters = { ...state.listFilters, ...payload }
    },
    resetListFilters: (state) => {
      state.listFilters = initialState.listFilters
    },
    setDetailActiveTab: (state, { payload }) => {
      state.detailActiveTab = payload
    },
  },
})

export default procurementSlice.reducer

export const { setListFilters, resetListFilters, setDetailActiveTab } =
  procurementSlice.actions

export const selectListFilters = (state) => state.procurement.listFilters
export const selectDetailActiveTab = (state) => state.procurement.detailActiveTab
